<template lang="pug">
  #listview.container
    .empty(v-if='!hasActiveMarkers && !isLoadingResources')
      p.empty-title.h5 No resources found
      p.empty-subtitle Try activating some categories
    .empty(v-if='!hasActiveMarkers && isLoadingResources')
      p.empty-title.h5 Loading...

    .columns
      .resource-listing.column.col-4.col-xl-6.col-md-12(
        ref='listing'
        v-for='(resource, key) in visibleResources'
        :id='"listing-" + resource.placeID')
        .card
          .card-header
            img.category-icon(:src='resource.icon')
            span {{resource.title}}
            div(v-if='resource.phone')
              small
                a(:href='resource.phoneLink') {{resource.phone}}
            div(v-if='resource.mapURL')
              small
                a(:href='resource.mapURL') {{resource.formattedAddress}}
            div(v-if='resource.website')
              small
                a(:href='resource.website') {{resource.website}}
          .card-body(v-if='resource.notes')
            pre {{resource.notes}}
          .card-footer
            p.btn-group.btn-group-block
              button.btn.btn-link(v-if='resource.lng || resource.lat' @click='showStreetView(resource)') Show street view
              button.btn(v-if='resource.lng || resource.lat' @click='showOnMap(resource)') Show on map
            .btn-group.btn-group-block(v-if='user.uid && view !== "checklist"')
              button.btn(@click='editResource(resource)') Edit
</template>





<script>
  import {mapState} from 'vuex'

  export default {
    name: 'resource-listing',

    computed: mapState([
      'activeCategories',
      'hasActiveMarkers',
      'isLoadingResources',
      'visibleResources',
      'user',
      'view',
      'checklist'
    ]),

    created () {
      this.$bus.$on('focusListing', this.focusListing)
    },

    watch: {
      // Force an update when the route changes
      view () {
        this.$forceUpdate()
      }
    },

    methods: {
      showOnMap (resource) {
        this.$bus.$emit('focusMarker', resource)
      },

      showStreetView (resource) {
        this.$bus.$emit('toggleStreetView', {
          lat: resource.lat,
          lng: resource.lng,
          pano: resource.pano,
          pov: resource.pov
        })
      },

      focusListing (resource) {
        const $listing = this.$root.$children[0].$refs.resourceListing.$el.querySelector(`#listing-${resource.placeID}`)
        if ($listing) {
          this.$root.$children[0].$refs.footer.scrollTop = $listing.offsetTop - this.$el.offsetTop
        }
      },

      editResource (resource) {
        this.$store.commit('toggleResourceModal', resource)
      }
    }
  }
</script>




<style lang="sass">
  #app[data-view='checklist']
    #listview
      .column
        width: 100%

  .card-header
    a
      overflow: hidden
      text-overflow: ellipsis
      max-width: 100%
      display: inline-block
</style>



// WEBPACK FOOTER //
// src/components/resource/Listing.vue